// データ一覧表示で利用するテーブルのコンポーネント定義
import { TableRow, withStyles } from '@material-ui/core';
// 表の各行
export const ListTableRow = withStyles({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#F5F5F5',
      color: '#fff'
    }
  },
  expanded: {}
})(TableRow);
